import { setLocale } from '@/i18n';
import { localePrefix, QURAN_LOCALES } from '@/utils/quran/locale';

const QuranLayout = () => import('@/pages/quran/QuranLayout.vue');

const SURAH = ':surah(\\d+)';
const AYAH = ':ayah(\\d+)';

/** Surahs run 1…114; anything else goes back to the index. */
function validSurah(to) {
  const n = Number(to.params.surah);
  return n >= 1 && n <= 114 ? true : { path: `${localePrefix(to.meta.quranLocale)}/quran/` };
}

/**
 * The same pages once per language: /quran/… (English), /bs/quran/… and so
 * on. meta.quranLocale tells the router which language to switch to.
 */
const pagesFor = (locale) => {
  const name = (n) => (locale === 'en' ? n : `${n}.${locale}`);
  return {
    path: `${localePrefix(locale)}/quran`,
    component: QuranLayout,
    meta: { layout: 'App', quranLocale: locale },
    children: [
      { path: '', name: name('quran'), component: () => import('@/pages/quran/QuranIndex.vue') },
      { path: 'search', name: name('quran.search'), component: () => import('@/pages/quran/QuranSearch.vue') },
      { path: 'words', name: name('quran.words'), component: () => import('@/pages/quran/QuranWords.vue') },
      { path: 'chronology', name: name('quran.chronology'), component: () => import('@/pages/quran/QuranChronology.vue') },
      { path: 'roots', name: name('quran.roots'), component: () => import('@/pages/quran/QuranRoots.vue') },
      { path: 'roots/:root', name: name('quran.root'), component: () => import('@/pages/quran/QuranRoot.vue') },
      { path: 'tafsir', name: name('quran.tafsir'), component: () => import('@/pages/quran/QuranTafsirIndex.vue') },
      { path: `tafsir/${SURAH}`, name: name('quran.tafsir.surah'), component: () => import('@/pages/quran/QuranTafsirSurah.vue'), beforeEnter: validSurah },
      { path: SURAH, name: name('quran.surah'), component: () => import('@/pages/quran/QuranSurah.vue'), beforeEnter: validSurah },
      { path: `${SURAH}/${AYAH}`, name: name('quran.ayah'), component: () => import('@/pages/quran/QuranAyah.vue'), beforeEnter: validSurah },
    ],
  };
};

export default [
  ...QURAN_LOCALES.map(pagesFor),
  // A language on its own has no page of its own: the home page, in that language.
  ...QURAN_LOCALES.filter((locale) => locale !== 'en').map((locale) => ({ path: `/${locale}`, redirect: () => { setLocale(locale); return '/'; } })),
];
